interface calculateTotalLoanRequiredArgs {
  preference_mortgage_reason: MortgageReason
  additional_loans: Case['additional_loans']
  preference_loan_amount: string
}

const calculateTotalLoanRequired = ({
  preference_mortgage_reason,
  additional_loans,
  preference_loan_amount,
}: calculateTotalLoanRequiredArgs) => {
  const isAdditionalLoansAllowed =
    preference_mortgage_reason == 'REASON_REMORTGAGE' || preference_mortgage_reason == 'REASON_BTL_REMORTGAGE'

  const total_additional_loan_amount: number =
    additional_loans?.reduce((total: number, loan) => total + parseInt(loan?.loan_amount || '0'), 0) || 0

  return isAdditionalLoansAllowed
    ? (parseInt(preference_loan_amount || '0') + total_additional_loan_amount).toString()
    : preference_loan_amount
}

export default calculateTotalLoanRequired
